import { FC } from 'react';
import { cn } from 'shared/lib';

interface IProps<T extends string> {
  tabs: readonly T[];
  activeTab: T;
  activeClassName?: string;
  className?: string;
  itemClassName?: string;
  containerClassName?: string;
  setActiveTab: (tab: T) => void;
  borderOff?: boolean;
}

export const Tabs = <T extends string>({
  tabs,
  className,
  activeTab,
  setActiveTab,
  itemClassName,
  activeClassName,
  containerClassName,
  borderOff
}: IProps<T>) => {
  return (
    <div
      className={cn(
        `${borderOff ? '' : 'ag-border-b ag-border-gray-200'}`,
        className
      )}
    >
      <div className={cn('ag-flex ag-gap-5', containerClassName)}>
        {tabs.map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={cn(
              'ag-relative ag-select-none ag-text-sm ag-pt-[1px] ag-px-1 ag-pb-[11px] ag-cursor-pointer ag-font-medium',
              itemClassName,
              activeTab === tab
                ? 'ag-text-dark-purple ag-transition-all ag-duration-200 ag-border-primary-700'
                : 'ag-text-neutral-500',
              activeTab === tab && activeClassName
            )}
          >
            {tab}
            {activeTab === tab && (
              <span className="ag-absolute ag-left-0 ag-bottom-0 ag-w-full ag-h-[2px] ag-bg-primary-700" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
